import Api from '@/services/Api'

//export object with a register method
export default {
    register (credentials) {
        //pass email and password to axios post method
        return Api().post('register', credentials)
    },
    login (credentials) {
        //pass email and password to axios post method
        return Api().post('login', credentials)
    }
}
